<script lang="ts">
    import type { Price } from '@shared/types/types';

    interface Props {
        unitPrice?: Price['normPrice'];
    }

    let { unitPrice }: Props = $props();
</script>

{#if unitPrice}
    <span class="oc-copy-75">
        ({unitPrice.value} €/ {unitPrice.amount}
        {unitPrice.unit})
    </span>
{/if}
